import { Link, useNavigate } from "react-router-dom";
import Logo from "./logo";
import "./Navbar.css";

export default function Navbar() {
  const navigate = useNavigate();
  const token = localStorage.getItem("token") || sessionStorage.getItem("token");
  const username = localStorage.getItem("username") || sessionStorage.getItem("username");

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("username");
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("username");

    navigate("/");
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-brand">
          <Logo />
        </Link>

        {token ? (
          <>
            <div className="navbar-links">
              <Link to="/analytics" className="nav-link">
                <span className="link-icon">📊</span>
                Analytics
              </Link>
              <Link to="/dashboard" className="nav-link">
                <span className="link-icon">📈</span>
                Dashboard
              </Link>
              <Link to="/daily" className="nav-link">
                <span className="link-icon">📝</span>
                Daily
              </Link>
              <Link to="/weekly" className="nav-link">
                <span className="link-icon">📅</span>
                Weekly
              </Link>
              <Link to="/monthly" className="nav-link">
                <span className="link-icon">📊</span>
                Monthly
              </Link>
              <Link to="/quarterly" className="nav-link">
                <span className="link-icon">🎯</span>
                Quarterly
              </Link>
            </div>

            <div className="navbar-right">
              {username && (
                <span className="user-badge">
                  <span className="user-avatar">👤</span>
                  {username}
                </span>
              )}
              <Link to="/settings" className="settings-btn">
                <span>⚙️</span>
                Settings
              </Link>
              <button onClick={handleLogout} className="logout-btn">
                <span>🚪</span>
                Logout
              </button>
            </div>
          </>
        ) : (
          <div className="navbar-empty">
            <span className="navbar-message">Welcome to SelfPivot</span>
          </div>
        )}
      </div>
    </nav>
  );
}